$(document).ready(function () {
  var elevateZoomDefaultConfig = {
    zoomWindowFadeIn: 500,
    zoomLensFadeIn: 500,
    gallery: "gal1",
    imageCrossfade: true,
    zoomWindowWidth: 450,
    zoomWindowHeight: 448,
    zoomWindowOffetx: 36,
    scrollZoom: true,
    responsive: true,
    cursor: "pointer",
  };

  $("#img_01").elevateZoom(elevateZoomDefaultConfig);

  
  // リサイズイベントのハンドリング
  $(window).resize(function () {
    $(".zoomContainer").remove();
    $("#img_01").removeData("elevateZoom");
    $("#img_01").removeData("zoomImage");

    var newWidth = $("#img_01").width();
    $("#img_01").elevateZoom({
      zoomWindowWidth: newWidth,
      zoomWindowHeight: newWidth,
    scrollZoom: true,
    });
  });

  // ギャラリー画像のクリックイベント
  $(".elevatezoom-gallery").on("click", function (e) {
    e.preventDefault();
    var ez = $("#img_01").data("elevateZoom");
    var smallImage = $(this).data("image");
    var largeImage = $(this).data("zoom-image");
    $("#img_01").attr('data-zoom-image', largeImage);
    ez.swaptheimage(smallImage, largeImage);
  });


var elevateZoomDefaultConfig2 = {
    zoomWindowFadeIn: 500,
    zoomLensFadeIn: 500,
    gallery: "gal2",
    imageCrossfade: true,
    zoomWindowWidth: 450,
    zoomWindowHeight: 448,
    zoomWindowOffetx: 36,
    scrollZoom: true,
    responsive: true,
    cursor: "pointer",
  };

  $("#img_02").elevateZoom(elevateZoomDefaultConfig2);

  
  // リサイズイベントのハンドリング
  $(window).resize(function () {
    $(".zoomContainer").remove();
    $("#img_02").removeData("elevateZoom");
    $("#img_02").removeData("zoomImage");

    var newWidth = $("#img_02").width();
    $("#img_02").elevateZoom({
      zoomWindowWidth: newWidth,
      zoomWindowHeight: newWidth,
    scrollZoom: true,
    });
  });

  // ギャラリー画像のクリックイベント
  $(".elevatezoom-gallery2").on("click", function (e) {
    e.preventDefault();
    var ez = $("#img_02").data("elevateZoom");
    var smallImage = $(this).data("image");
    var largeImage = $(this).data("zoom-image");
    $("#img_02").attr('data-zoom-image', largeImage);
    ez.swaptheimage(smallImage, largeImage);
  });
  
  // ============================================
  // SP用スライダー
  // ============================================
  $(".flexslider").flexslider({
    animation: "slide",
    controlNav: "thumbnails",
    animationLoop: "true",
    start: function (slider) {
      $("body").removeClass("loading");
    },
  });
});

 // ============================================
  // 抱っこ紐howtowページ用スライダー
  // ============================================
  $('.howto-illustration__slider .slides').slick({
    infinite:        true,
    slidesToShow:    1,
    slidesToScroll:  1,
    arrows:          true,
    dots:            true,
    centerMode:      false,
    variableWidth: true,
    customPaging: function(slider, i) {
      return '<button class="slick-dot"></button>';
    },
    prevArrow:  '<button class="slick__prev" type="button"><span class="howto-babycarrier prevText"></span></button>',
    nextArrow:  '<button class="slick__next" type="button"><span class="howto-babycarrier nextText"></span></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll:1,
          variableWidth:  false  // ← SPでは幅固定（100%）に切り替え
        }
      }
    ]
  });
  